/**
 * Hardware / side-effect approvals (Cursor Run Modes analogue).
 * Returns true if the user confirmed.
 */
export async function requestHardwareApproval(opts: {
  title: string;
  detail: string;
}): Promise<boolean> {
  // Prefer native confirm for reliability across panels; keep copy explicit.
  const ok = window.confirm(`${opts.title}\n\n${opts.detail}\n\n¿Continuar?`);
  return ok;
}

/** File / code export from workbench or chat. */
export async function requestExportApproval(opts: {
  filename: string;
  detail?: string;
}): Promise<boolean> {
  return requestHardwareApproval({
    title: `Exportar: ${opts.filename}`,
    detail:
      opts.detail ||
      "Se descargará un archivo a tu dispositivo. Confirma solo si es lo que quieres exportar.",
  });
}
